import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../services/auth.service';

/**
 * Gates every authenticated Internal Portal route.
 *
 * Consignment.Web is the internal staff portal (the consignor-facing app is a
 * separate portal), so access requires a valid JWT whose `userOrigin` is
 * `Internal` — identical to the Donation portal's guard.
 *
 * Unauthenticated → SSO with returnUrl so the user lands back after login.
 * Authenticated but wrong origin → SSO with NO returnUrl (null) to prevent an
 * infinite redirect loop when Company SSO bounces them back.
 */
export const authGuard: CanActivateFn = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);

  if (!authService.isAuthenticated()) {
    authService.redirectToLogin(state.url);
    return false;
  }

  const userInfo = authService.getUserInfo();
  if (userInfo?.userOrigin && userInfo.userOrigin !== 'Internal') {
    authService.redirectToLogin(null);
    return false;
  }

  return true;
};
